<template>
  <div>
    <CardView>
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <FormTaskDefinition :id="this.$route.params.id" :taskDefinition="this.taskDefinition" @update="update"
            ></FormTaskDefinition>
          </div>
          <div class="col">
            <subtask-list :subtasks="subtasks"></subtask-list>
          </div>
        </div>
      </div>
    </CardView>
  </div>
</template>

<script>
import CardView from "@/components/cardView.vue";
import FormTaskDefinition from "@/components/taskDefinition/FormTaskDefinition.vue";
import {mapGetters} from "vuex";
import EditSubtask from "@/components/taskDefinition/EditSubtask.vue";
import AddSubtask from "@/components/taskDefinition/AddSubtask.vue";
import Subtask from "@/components/taskDefinition/Subtask.vue";
import SubtaskList from "@/components/taskDefinition/SubtaskList.vue";
// import firebase from "firebase";

export default {
  name: "taskDefinitionEdit",
  components: {SubtaskList, Subtask, AddSubtask, EditSubtask, FormTaskDefinition, CardView},
  computed: {
    ...mapGetters('users', ['getClaims', 'getSelectedWorkflow']),
    ...mapGetters('taskDefinitions', ["getTaskDefinitionsById"]),
    ...mapGetters("taskDefinitionSubtasks", ["getTaskDefinitionSubtaskByTaskDefinition"]),
  },
  data() {
    return {
      originalTaskDefinition: null,
      taskDefinition: null,
      originalSubtasks: null,
      subtasks: [],
    }
  },
  methods: {
    async update(taskDefinition) {
      const taskDefinitionId = await this.saveTaskDefinition(taskDefinition)
      await this.saveSubtasks(taskDefinitionId)
      this.$router.push({name: 'task-definitions-overview'})
    },
    async saveSubtasks(taskDefinitionId) {

      for (const [index, subtask] of this.subtasks.entries()) {

        subtask.sequence = index
        let subtaskToSave;
        this.file = subtask.file
        subtask.fileName = this.file && !subtask.fileName ? this.file.name :  (subtask.fileName ? subtask.fileName : null)

        if (!subtask.id) {

          this.fileRecord = subtask.fileRecord

          subtaskToSave = {
            ..._.omit(subtask, ['file', 'fileRecord']),
            companyId: this.getClaims.companyId,
            taskDefinitionId: taskDefinitionId
          }
        } else {
          subtaskToSave = {
            ..._.omit(subtask,['file','fileRecord']),
          }
        }
        try {
          let docId = await this.$store.dispatch("taskDefinitionSubtasks/set", subtaskToSave);
          if (this.file) {
            const storageRef = this.$FB_STORAGE
                .ref("taskDefinitionSubtasks/" + this.getClaims.companyId + "/" + docId + "/" + this.file.name);
            await storageRef
                .put(this.file)
                .then(function () {
                  console.log("Uploaded succesfully");
                })
                .catch((error) => {
                  console.log(error.message);
                });
          }
        } catch (e) {
          throw e
        }
      }
      this.swalToastSuccess(this.$t("ui.saved"))
    },
    async saveTaskDefinition(taskDefinition) {
      let taskDefinitionToSave = {
        ...taskDefinition,
        amountOfSubtasks: this.subtasks.length,
        companyId: this.getClaims.companyId,
      }
      let docId = await this.$store.dispatch("taskDefinitions/set", taskDefinitionToSave);
      console.log("SaveTaskDefinition: ", taskDefinitionToSave, "; ", docId)
      return docId
    },
    getTaskDefinition(taskDefinitionId) {
      this.taskDefinition = this.getTaskDefinitionsById(taskDefinitionId)
    },
    getSubtasksByTaskDefinition(taskDefinitionId) {
      this.subtasks = this.getTaskDefinitionSubtaskByTaskDefinition(taskDefinitionId)
    },
  },
  created() {
    this.getTaskDefinition(this.$route.params.id)
    this.getSubtasksByTaskDefinition(this.$route.params.id)
  }
}
</script>

<style scoped>
</style>
